var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tabsViews_box",
      staticStyle: {
        height: "34px",
        "border-bottom": "1px solid #d2d2d2",
        "margin-bottom": "16px",
        "box-shadow":
          "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 0 3px 2px rgba(103,103, 103, 0.1)"
      }
    },
    [
      _c(
        "scroll-pane",
        { ref: "scrollPane", staticClass: "tags-view-wrapper" },
        _vm._l(_vm.dynamicTags, function(tag) {
          return _c(
            "el-tag",
            {
              key: tag.meta.index,
              staticClass: "cursors",
              staticStyle: { margin: "4px 0px 4px 7px" },
              attrs: {
                size: "small",
                effect: _vm.isActive == tag.path ? "dark" : "plain",
                closable: tag.meta.name == "首页" ? false : true,
                "disable-transitions": true
              },
              on: {
                click: function($event) {
                  return _vm.handleClick(tag)
                },
                close: function($event) {
                  return _vm.handleClose(tag)
                }
              }
            },
            [_vm._v("\n             " + _vm._s(tag.meta.name) + "\n         ")]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-798ff5b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../45/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798ff5b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../45/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabsViews.vue
// module id = null
// module chunks = 